// import React from 'react';
// import { motion } from 'framer-motion';
// import styled from 'styled-components';
// import { 
//     Cpu, 
//     ArrowUpRight, 
//     Zap, 
//     ShieldCheck, 
//     BarChart3, 
//     Network,
//     Users
// } from 'lucide-react';

// const MeridaVision = () => {
//     const pillars = [
//         { title: "Organizational Scalability", icon: <Network />, desc: "Frameworks built for rapid expansion.", color: "#38bdf8" },
//         { title: "Operational Continuity", icon: <ShieldCheck />, desc: "Ensuring stability during growth.", color: "#2dd4bf" },
//         { title: "Workforce Efficiency", icon: <Zap />, desc: "Maximizing output through strategy.", color: "#a855f7" },
//         { title: "Recruitment Intelligence", icon: <Cpu />, desc: "AI-driven talent acquisition.", color: "#818cf8" },
//         { title: "Leadership Alignment", icon: <Users />, desc: "Connecting vision with execution.", color: "#f472b6" },
//         { title: "Business Performance", icon: <BarChart3 />, desc: "Measurable long-term growth.", color: "#22d3ee" }
//     ];

//     return (
//         <SectionContainer>
//             <div className="container mx-auto px-6 relative z-10">
//                 <div className="grid lg:grid-cols-12 gap-16 items-center">

//                     {/* LEFT SIDE: THE TEXT ARCHITECTURE */}
//                     <div className="lg:col-span-5">
//                         <motion.div
//                             initial={{ opacity: 0, y: 30 }}
//                             whileInView={{ opacity: 1, y: 0 }}
//                             transition={{ duration: 0.8 }}
//                         >
//                             <span className="text-blue-400 font-mono tracking-[0.4em] text-xs uppercase mb-6 block italic">
//                                 /// Strategic Engineering
//                             </span>
//                             <h2 className="text-4xl md:text-7xl font-bold syne text-white leading-none mb-10">
//                                 Redefining <br/> <span className="text-blue-500">Workforce</span> <br/> Logic.
//                             </h2>
//                             <p className="text-blue-100/50 text-lg leading-relaxed mb-10 max-w-md">
//                                 At Merida HR Consulting, we believe workforce consulting should extend far beyond traditional recruitment delivery. We build the systems that drive modern organizations.
//                             </p>

//                             <motion.button
//                                 whileHover={{ scale: 1.05 }}
//                                 whileTap={{ scale: 0.95 }}
//                                 className="group bg-white text-[#01014C] px-10 py-5 rounded-full font-black uppercase tracking-widest text-xs flex items-center gap-4 transition-all hover:bg-blue-500 hover:text-white shadow-2xl"
//                             >
//                                 Talk To Workforce Experts
//                                 <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
//                             </motion.button>
//                         </motion.div>
//                     </div>

//                     {/* RIGHT SIDE: 3D LOUVER PANELS */}
//                     <div className="lg:col-span-7 h-[600px] flex items-center justify-center perspective-container">
//                         <div className="louver-grid">
//                             {pillars.map((item, index) => (
//                                 <motion.div
//                                     key={index}
//                                     className="louver-panel"
//                                     initial={{ opacity: 0, rotateY: -30, x: 50 }}
//                                     whileInView={{ opacity: 1, rotateY: -20, x: 0 }}
//                                     transition={{ delay: index * 0.1, duration: 0.8 }}
//                                     whileHover={{ 
//                                         width: "300px", 
//                                         rotateY: 0,
//                                         zIndex: 50,
//                                         transition: { type: "spring", stiffness: 300, damping: 20 }
//                                     }}
//                                 >
//                                     <div className="panel-content" style={{ '--accent': item.color }}>
//                                         {/* Vertically Aligned Label */}
//                                         <div className="vertical-label">
//                                             0{index + 1}
//                                         </div>

//                                         {/* Expanded Content (Visible on Hover) */}
//                                         <div className="reveal-box">
//                                             <div className="icon-wrap">{item.icon}</div>
//                                             <h4 className="panel-title">{item.title}</h4>
//                                             <p className="panel-desc">{item.desc}</p>
//                                         </div>

//                                         {/* Blueprint Grid Lines Effect */}
//                                         <div className="blueprint-lines" />
//                                     </div>
//                                 </motion.div>
//                             ))}
//                         </div>
//                     </div>

//                 </div>
//             </div>
//         </SectionContainer>
//     );
// };

// const SectionContainer = styled.section`
//     background-color: #01014C;
//     padding: 150px 0;
//     overflow: hidden;
//     position: relative;

//     .perspective-container {
//         perspective: 2000px;
//     }

//     .louver-grid {
//         display: flex;
//         gap: 15px;
//         height: 450px;
//         transform-style: preserve-3d;
//     }

//     .louver-panel {
//         width: 60px;
//         height: 100%;
//         background: rgba(255, 255, 255, 0.03);
//         border: 1px solid rgba(255, 255, 255, 0.1);
//         border-radius: 20px;
//         position: relative;
//         cursor: pointer;
//         overflow: hidden;
//         backdrop-filter: blur(10px);
//     }

//     .panel-content {
//         position: relative;
//         width: 100%;
//         height: 100%;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//     }

//     .vertical-label {
//         writing-mode: vertical-rl;
//         text-orientation: mixed;
//         color: white;
//         font-weight: 900;
//         font-size: 24px;
//         opacity: 0.3;
//         transition: 0.3s;
//     }

//     .louver-panel:hover .vertical-label {
//         opacity: 0;
//     }

//     /* REVEAL ON HOVER */
//     .reveal-box {
//         position: absolute;
//         inset: 0;
//         padding: 30px;
//         opacity: 0;
//         display: flex;
//         flex-direction: column;
//         justify-content: flex-end;
//         transition: 0.3s;
//         transform: scale(0.9) translateX(-20px);
//     }

//     .louver-panel:hover .reveal-box {
//         opacity: 1;
//         transform: scale(1) translateX(0);
//         transition-delay: 0.2s;
//     }

//     .icon-wrap {
//         width: 50px;
//         height: 50px;
//         background: var(--accent);
//         border-radius: 12px;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         color: #01014C;
//         margin-bottom: 20px;
//         box-shadow: 0 0 20px var(--accent);
//     }

//     .panel-title {
//         color: white;
//         font-weight: 800;
//         font-size: 18px;
//         margin-bottom: 8px;
//         font-family: 'Inter', sans-serif;
//     }

//     .panel-desc {
//         color: rgba(255, 255, 255, 0.5);
//         font-size: 12px;
//         line-height: 1.5;
//     }

//     /* BLUEPRINT LINES EFFECT */
//     .blueprint-lines {
//         position: absolute;
//         inset: 0;
//         background-image: 
//             linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px),
//             linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px);
//         background-size: 20px 20px;
//         opacity: 0;
//         transition: 0.5s;
//     }

//     .louver-panel:hover .blueprint-lines {
//         opacity: 1;
//     }

//     .louver-panel:hover {
//         background: rgba(255, 255, 255, 0.08);
//         border-color: var(--accent);
//     }
// `;

// export default MeridaVision;



import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import CTAButton from '../CTAButton';
import {
    Maximize,
    RefreshCcw,
    Zap,
    BrainCircuit,
    Users2,
    LineChart,
    ArrowRight
} from 'lucide-react';

const MeridaVision = () => {
    const navigate = useNavigate();
    const pillars = [
        { title: "Organizational Scalability", icon: <Maximize />, 
            desc: "Building adaptable frameworks, streamlined processes, and people-centric strategies that empower your organization to scale efficiently, embrace growth opportunities, and achieve long-term success with confidence.", 
            color: "#3b82f6" },
        { title: "Operational Continuity", icon: <RefreshCcw />,
             desc: "Ensuring your business never skips a beat through resilient processes, proactive planning, and workforce strategies that maintain productivity, minimize disruptions, and support uninterrupted operations.", 
             color: "#6366f1" },
        { title: "Workforce Efficiency", 
            icon: <Zap />, 
            desc: "Optimizing talent output through smart systems, streamlined workflows, and data-driven workforce strategies that enhance productivity, improve collaboration, and maximize organizational performance.", 
            color: "#06b6d4" },
        { title: "Recruitment Intelligence", 
            icon: <BrainCircuit />, 
            desc: "Leveraging AI-driven sourcing, advanced analytics, and intelligent screening tools to identify, attract, and hire top talent with greater accuracy, speed, and efficiency.",
             color: "#8b5cf6" },
        { title: "Leadership Alignment", 
            icon: <Users2 />, 
            desc: "Connecting management goals with team execution through clear communication, strategic direction, and collaborative frameworks that ensure every level of the organization works toward shared objectives.",
             color: "#3b82f6" },
        { title: "Business Performance", 
            icon: <LineChart />, 
            desc: "Achieving sustainable business growth by aligning workforce strategies with organizational goals, enabling higher performance, stronger engagement, and measurable results across the enterprise.",
             color: "#0ea5e9" }
    ];

    return (
        <SectionContainer>
            <div className="container mx-auto px-6">

                {/* --- HEADER SECTION --- */}
                <div className="flex flex-col lg:flex-row justify-between items-end mb-12 gap-8">
                    <div className="max-w-3xl">
                        <motion.span
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            className="text-blue-600 font-bold tracking-[0.3em] text-[10px] uppercase block mb-4"
                        >
                            Our Strategic Philosophy
                        </motion.span>
                        <motion.h2
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.2 }}
                            className="text-3xl md:text-5xl font-bold text-slate-900 syne leading-tight"
                        >
                            Redefine How You Build <br />
                            <span className="text-blue-600">Workforce Systems.</span>
                        </motion.h2>
                    </div>

                    <motion.div
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ delay: 0.4 }}
                        className="lg:w-1/3"
                    >
                        <p className="text-slate-500 text-lg leading-relaxed border-l-2 border-slate-100 pl-6">
                            At Merida HR Consulting, we believe workforce consulting should extend far beyond traditional recruitment delivery.
                        </p>
                    </motion.div>
                </div>

                {/* --- THE BENTO ASSEMBLY GRID --- */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {pillars.map((item, index) => (
                        <BentoCard
                            key={index}
                            initial={{ opacity: 0, y: 30, scale: 0.95 }}
                            whileInView={{ opacity: 1, y: 0, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.1, duration: 0.5 }}
                            whileHover={{ y: -8, transition: { duration: 0.3 } }}
                            className="group relative rounded-[2rem] p-10 overflow-hidden cursor-default transition-all"
                        >
                            {/* Abstract Number background */}
                            <span className="absolute -right-4 -top-4 text-9xl font-black text-slate-200 group-hover:text-blue-50 transition-colors pointer-events-none">
                                0{index + 1}
                            </span>

                            <div className="relative z-10">
                                <div className="w-14 h-14 rounded-2xl bg-white shadow-sm flex items-center justify-center text-[#01014C] mb-8 group-hover:bg-[#01014C]/10 group-hover:text-[#01014C] transition-all duration-500">
                                    {item.icon}
                                </div>
                                <h4 className="text-xl font-bold text-slate-900 mb-4">{item.title}</h4>
                                <p className="text-slate-500 text-sm leading-relaxed ">
                                    {item.desc}
                                </p>
                            </div>

                            {/* The "Growth" line animation */}
                            <div className="absolute bottom-0 left-0 w-0 h-1 bg-blue-600 group-hover:w-full transition-all duration-700" />
                        </BentoCard>
                    ))}
                </div>

                {/* --- FINAL QUOTE & CTA --- */}
                <div className="mt-20 flex flex-col items-center">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        className="max-w-4xl text-center flex flex-col items-center"
                    >
                        <p className="text-xl md:text-xl text-slate-700 font-medium  mb-12">
                            "We are building workforce solutions designed to help organizations <span className="text-blue-600">adapt faster, hire smarter,</span> operate more efficiently, and scale more sustainably."
                        </p>

                        <CTAButton 
                            text="Talk To Workforce Experts"
                            onClick={() => navigate('/contact')}
                            type="secondary"
                        />
                    </motion.div>
                </div>

            </div>
        </SectionContainer>
    );
};


const SectionContainer = styled.section`
    background-color: #ffffff;
    padding: 120px 0;
    overflow: hidden;
    position: relative;
    
    /* Subtle geometric texture to break up the white */
    &::after {
        content: '';
        position: absolute;
        top: 0; right: 0;
        width: 400px; height: 400px;
        background: radial-gradient(circle, rgba(59, 130, 246, 0.03) 0%, transparent 70%);
        pointer-events: none;
    }
`;

const BentoCard = styled(motion.div)`
  border: 1px solid rgba(1, 1, 76, 0.15) !important;
  background-color: #f8fafc !important;
  transition: border-color 0.4s ease, background 0.4s ease, box-shadow 0.4s ease !important;

  &:hover {
    border-color: rgba(1, 1, 76, 0.25) !important;
    background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%) !important;
    box-shadow: 0 20px 40px rgba(1, 1, 76, 0.06) !important;
  }
`;

export default MeridaVision;